// get_job
export const GET_JOB = 'get_job';
export const GET_JOB_SUCCESSFUL = 'get_job_successfull';
export const GET_JOB_FAILED = 'get_job_failed';

// create_job
export const CREATE_JOB = 'create_job';
export const CREATE_JOB_SUCCESSFUL = 'create_job_successfull';
export const CREATE_JOB_FAILED = 'create_job_failed';

// update_job
export const UPDATE_JOB = 'update_job';
export const UPDATE_JOB_SUCCESSFUL = 'update_job_successfull';
export const UPDATE_JOB_FAILED = 'update_job_failed';

// delete_job
export const DELETE_JOB = 'delete_job';
export const DELETE_JOB_SUCCESSFUL = 'delete_job_successfull';
export const DELETE_JOB_FAILED = 'delete_job_failed';
